import API from 'types/api';
import _ from 'lodash';
import localStorageUtils from 'utils/localStorageUtils';

const initialState = {
  language: localStorageUtils.getItem('lang'),
  languages: [
    { id: 'ru', title: 'Русский' },
    { id: 'ua', title: 'Українська' },
    { id: 'en', title: 'English' },
    { id: 'by', title: 'Беларуская' },
    { id: 'lv', title: 'Latviešu' },
    { id: 'lt', title: 'Lietuvių' },
    { id: 'ee', title: 'Eesti' },
  ],
  paymentSystems: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.GET_CONFIGURATION_FETCH:
      return {
        ...state,
        ...payload,
        isLoading: true,
        isError: false,
      };

    case API.GET_CONFIGURATION_SUCCESS:
      return {
        ...state,
        ...payload,
        isLoading: false,
        isError: false,
      };

    case API.GET_CONFIGURATION_ERROR:
      return {
        ...state,
        ...payload,
        isLoading: false,
        isError: true,
      };

    case API.GET_PAYMENTS_SYSTEM_FETCH:
      return {
        ...state,
        ...payload,
        isLoading: true,
        isError: false,
      };

    case API.GET_PAYMENTS_SYSTEM_SUCCESS:
      return {
        ...state,
        paymentSystems: _.get(payload, 'payment_systems', []),
        isLoading: false,
        isError: false,
      };

    case API.GET_PAYMENTS_SYSTEM_ERROR:
      return {
        ...state,
        ...payload,
        isLoading: false,
        isError: true,
      };

    default:
      return state;
  }
};
